/*eslint @typescript-eslint/no-unused-vars: off */
import * as Ecommerce from '@mailbiz/browser-plugin-ecommerce';
import * as Debug from '@mailbiz/browser-plugin-debugger';
import { plugins } from '../tracker.config';
import { BrowserPlugin } from '@mailbiz/browser-tracker-core';

import { JavaScriptTrackerConfiguration } from './configuration';

/**
 * Calculates the required plugins to intialise per tracker
 * @param _configuration - The tracker configuration object
 */
export function Plugins(_configuration: JavaScriptTrackerConfiguration) {
  const activatedPlugins: Array<[BrowserPlugin, {} | Record<string, Function>]> = [];

  if (plugins.debug) {
    const { DebuggerPlugin, ...apiMethods } = Debug;
    activatedPlugins.push([DebuggerPlugin(), apiMethods]);
  }

  if (plugins.ecommerce) {
    const { EcommercePlugin, ...apiMethods } = Ecommerce;
    activatedPlugins.push([EcommercePlugin(), apiMethods]);
  }

  return activatedPlugins;
}
